import {
  CountryIso,
  getEarliestEndDate, getEarliestStartDate, getInitialEndTime, getInitialStartTime, getLatestEndDate, getLatestStartDate, Moment, Position
} from 'member-web-shared-components';
import { SearchBar } from 'member-web-shared-components/build/components/SearchBar/SearchBar';
import { GoogleMapsProvider } from 'member-web-shared-components/build/utils/providers/GoogleApiProvider/GoogleApiProvider';
import 'moment-timezone';
import moment from 'moment';
import { useState } from 'react';
import { NonMemberSearchBarProps } from '../../types/App';
import './NonMemberSearchBar.scss';

const NonMemberSearchBar = (props: NonMemberSearchBarProps) => {
  const {
    componentId, nonMemberSearchUrl, timezone, countryIso
  } = props;
  const offset = moment.tz(timezone).utcOffset();
  const initialStartTime = getInitialStartTime(offset);
  const initialEndTime = getInitialEndTime(offset);

  const [address, setAddress] = useState('');
  const [position, setPosition] = useState({} as Position);
  const [startTime, setStartTime] = useState<Moment>(initialStartTime);
  const [endTime, setEndTime] = useState<Moment>(initialEndTime);

  const getAddressPlaceholder = () => {
    switch (countryIso.toLowerCase()) {
      case CountryIso.GB:
        return '1 The Strand, London UK';
      case CountryIso.CA:
        return '1 Yonge Street, Toronto ON';
      default:
        return '1 Main St, Boston MA';
    }
  };

  const updateAddress = (_position: Position, _address: string) => {
    setAddress(_address);
    setPosition(_position);
  };

  const updateStartTime = (_startTime: Moment) => {
    setStartTime(_startTime);
  };

  const updateEndTime = (_endTime: Moment) => {
    setEndTime(_endTime);
  };

  const search = () => {
    const searchParams = new URLSearchParams();
    window.optimizely = window.optimizely || [];
    window.optimizely.push({
      type: 'event',
      eventName: 'nms_presales_search'
    });

    if (address) {
      searchParams.append('address', address.toString());
    }

    if (startTime) {
      searchParams.append('startTime', startTime.toString());
    }

    if (endTime) {
      searchParams.append('endTime', endTime.toString());
    }

    if (position.lat) {
      searchParams.append('lat', String(position.lat));
    }

    if (position.lng) {
      searchParams.append('lng', String(position.lng));
    }

    searchParams.toString();
    const nmsUrl = `${nonMemberSearchUrl}?${searchParams}`;
    window.location.href = nmsUrl;
  };

  return (
    <GoogleMapsProvider googleMapsApiKey='AIzaSyDPtl_iW6kuZNqi0pFabIWZEQwPMAZff5Y' libraries={['places']}>
      <div
        data-testid={componentId}
        className='presales-search-bar'
      >
        <SearchBar
          address={address}
          disabled={false}
          endTime={endTime}
          searchBarBorder={false}
          handleEndChange={updateEndTime}
          handleStartChange={updateStartTime}
          maxEndDate={getLatestEndDate(endTime, offset)}
          maxStartDate={getLatestStartDate(offset)}
          minEndDate={getEarliestEndDate(startTime, offset)}
          minStartDate={getEarliestStartDate(offset)}
          offset={offset}
          startTime={startTime}
          timezone={timezone || 'America/New_York'}
          isMobileSearchPanelOpen
          locale={countryIso || 'US'}
          buttonText='Search'
          selectAddress={updateAddress}
          startTimePickerLabel='Pick up'
          endTimePickerLabel='Return'
          onSearch={search}
          // eslint-disable-next-line @typescript-eslint/no-empty-function
          setMobileSearchPanelVisibility={() => {}}
          addressPlaceholder={getAddressPlaceholder()}
        />
      </div>
    </GoogleMapsProvider>
  );
};

export default NonMemberSearchBar;
